// extracted by mini-css-extract-plugin
export default {"canvas":"AudioVisualiser_canvas__7X8Qd"};